<template>
    <span class="pull-right-container">
        <small class="label pull-right bg-green" v-if="unreadEventsCount > 0">{{ unreadEventsCount}}</small>
    </span>
</template>

<script>
    export default {
        props: ['initUnreadEventsCount'],
        data: function () {
            return {
                unreadEventsCount: this.initUnreadEventsCount
            }
        },
        created() {
            window.AppEventBus.$on('eventRead', () => {
                this.unreadEventsCount --;
            })
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/sidebar/unreadEventsCount.vue